import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const MaintenanceBanner = ({ startDate, endDate }) => {
  const formatTime = (date) => {
    if (!date) return '';
    const utcTime = dayjs.utc(date).format('DD-MM-YYYY HH:mm');
    const localTime = dayjs.utc(date).local().format('HH:mm');
    return `${utcTime} UTC (${localTime} local)`;
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: '#ff6b6b',
        color: 'white',
        padding: '12px 20px',
        textAlign: 'center',
        zIndex: 10000,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        fontSize: '14px',
        fontWeight: '500',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
        <span role="img" aria-label="warning" style={{ fontSize: '20px' }}>
          ⚠️
        </span>
        <div>
          <strong>MAINTENANCE MODE ACTIVE</strong> - You are viewing this site as an administrator.
          {startDate && endDate && (
            <div style={{ fontSize: '12px', marginTop: '4px', opacity: 0.9 }}>
              Maintenance window: {formatTime(startDate)} to {formatTime(endDate)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

MaintenanceBanner.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default MaintenanceBanner;
